export default "__VITE_ASSET__jGgojnaW$i535TJjps$I7w__"